// Treatment hero photography — one editorial image per treatment at /images/treatments/{slug}.webp (1264×848).
const TREATMENT_IMAGES = {
  injectables: { pos: "62% 35%", alt: "A doctor gently assessing a woman's cheek contour in a light consulting room" },
  "threads-and-regenerative": { pos: "55% 35%", alt: "A doctor drawing a fine planning line along a woman's jawline" },
  "skin-and-laser": { pos: "45% 45%", alt: "A woman wearing eye shields during a laser skin treatment" },
  "body-and-core-to-floor": { pos: "55% 40%", alt: "A woman seated on a treatment bed talking through a plan with her doctor" },
  "minor-procedures": { pos: "50% 45%", alt: "A doctor examining a small skin lesion on a forearm with a dermatoscope" },
  "bridal-and-events": { pos: "60% 40%", alt: "A bride-to-be fastening an earring by a tall window" },
  "lumiere-private": { pos: "50% 45%", alt: "A quiet private consulting room with a linen armchair and a view of the sea" },
};

export const treatmentImage = (slug) => {
  const meta = TREATMENT_IMAGES[slug];
  return meta ? { id: `/images/treatments/${slug}.webp`, pos: meta.pos, alt: meta.alt } : null;
};
